// @ts-check
import ProgressLayout from '@/components/layouts/ProgressLayout';
import CreatePage from '@/components/pages/envelopes/CreatePage';
import DocumentsPage from '@/components/pages/envelopes/DocumentsPage';
import ExpiryPage from '@/components/pages/envelopes/ExpiryPage';
import FieldsPage from '@/components/pages/envelopes/FieldsPage';
import NamePage from '@/components/pages/envelopes/NamePage';
import PartiesPage from '@/components/pages/envelopes/PartiesPage';
import ProgressPage from '@/components/pages/envelopes/ProgressPage';
import RemindersPage from '@/components/pages/envelopes/RemindersPage';
import SharingPage from '@/components/pages/envelopes/SharingPage';
import SigningSequencePage from '@/components/pages/envelopes/SigningSequencePage';
import SummaryPage from '@/components/pages/envelopes/SummaryPage';

const createRoute = {
  /**
   * Step 1 - Select document/s and template/s
   *
   */
  path: '/envelopes/create',
  name: 'EnvelopesCreate',
  component: CreatePage,
  meta: {
    title: 'createEnvelope',
    requiresAuth: true,
  },
};
const stepRoutes = {
  /**
   * StepsPage shows the current "step" with progress bar and back/next buttons
   */
  path: '/envelopes/:fingerprint',
  name: 'EnvelopesSteps',
  component: ProgressPage,
  meta: {
    title: 'createEnvelope',
    requiresAuth: true,
  },
  children: [
    {
      /**
       * Step 1 - Configure parties
       */
      path: 'documents',
      name: 'EnvelopesStepDocuments',
      component: DocumentsPage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
      props: true,
    },
    {
      /**
       * Step 2 - Configure parties
       */
      path: 'parties',
      name: 'EnvelopesStepParties',
      component: PartiesPage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
      props: true,
    },
    {
      /**
       * Step 3 - Fields
       */
      path: 'fields',
      name: 'EnvelopesStepFields',
      component: FieldsPage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
      props: true,
    },
    {
      /**
       * Step 4 - Summary
       */
      path: 'summary',
      name: 'EnvelopesStepSummary',
      component: SummaryPage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
      props: true,
    },
    {
      /**
       * Catch all - Steps page will redirect to correct step
       */
      path: '*',
    },
  ],
};

const editRoutes = {
  /**
   * EditPage shows the "step" in an edit state without progress bar
   */
  path: '/envelopes/:fingerprint/edit',
  name: 'EnvelopesEdit',
  component: ProgressLayout,
  meta: {
    title: 'createEnvelope',
    requiresAuth: true,
  },
  children: [
    {
      /**
       * Edit Name
       */
      path: 'name',
      name: 'EnvelopesEditName',
      component: NamePage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
    },
    {
      /**
       * Edit SigningSequence
       */
      path: 'signing-sequence',
      name: 'EnvelopesEditSigningSequence',
      component: SigningSequencePage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
    },
    {
      /**
       * Edit Sharing
       */
      path: 'sharing',
      name: 'EnvelopesEditSharing',
      component: SharingPage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
    },
    {
      /**
       * Edit Reminders
       */
      path: 'reminders',
      name: 'EnvelopesEditReminders',
      component: RemindersPage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
    },
    {
      /**
       * Edit Expiry
       */
      path: 'expiry',
      name: 'EnvelopesEditExpiry',
      component: ExpiryPage,
      meta: {
        title: 'createEnvelope',
        requiresAuth: true,
      },
    },
  ],
};

const routes = [createRoute, editRoutes, stepRoutes];

// Only export if not in production
const shouldExport =
  process.env.VUE_APP_ENV !== 'production' ||
  process.env.VUE_APP_IS_LOCAL === 'true';

export default shouldExport ? routes : [];
